export const ErroPesquisaVendedor = [[
{
    "isSuccess": true,
    "data": [
        [
            {
                "id": 892,
                "codigoVendedor": "234182",
                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                "basesErroPesquisaVendedor": [
                    {
                        "qtdErros": 13,
                        "tipoErro": "Capacidade Val."
                    },
                    {
                        "qtdErros": 2,
                        "tipoErro": "Preço SellIn Val."
                    },
                    {
                        "qtdErros": 12,
                        "tipoErro": "Preço SellOut Val."
                    },
                    {
                        "qtdErros": 30,
                        "tipoErro": "Produto Val."
                    }
                ]
            },
            {
                "id": 1077,
                "codigoVendedor": "251281",
                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                "basesErroPesquisaVendedor": [
                    {
                        "qtdErros": 1,
                        "tipoErro": "Preço SellOut Val."
                    }
                ]
            }
        ]
    ],
    "existentes": []
}
]


]

